import { PaginationParams } from 'vrlcm-gui-types';

export namespace RequestApiUri {
  const BASE_URL = '/lcm/request/api';

  export const REQUESTS_URL = `${BASE_URL}/requests`;

  export const GET_REQUESTS_URL = ({
    currentPage,
    pageSize,
    sortBy,
    sortByDirection,
    requestName,
    lastUpdatedOn,
    state
  }: PaginationParams) => {
    let url = `${BASE_URL}/requests/page?page=${currentPage}&limit=${pageSize}`;
    if (sortBy) {
      url += `&sortBy=${sortBy}`;
    }
    if (sortByDirection) {
      url += `&sortByDirection=${sortByDirection}`;
    }
    if (requestName) {
      url += `&requestName=${encodeURIComponent(requestName)}`;
    }
    if (lastUpdatedOn) {
      url += `&lastUpdatedOn=${lastUpdatedOn}`;
    }
    if (state) {
      url += `&state=${state}`;
    }
    return url;
  };

  export const REQUEST_URL = (requestId: string) =>
    `${BASE_URL}/requests/${requestId}`;

  export const GET_PRECHECK_REPORT_URL = (requestId: string) =>
    `${BASE_URL}/prevalidationreport?requestId=${requestId}`;

  export const CANCEL_REQUEST_URL = (requestId: string) =>
    `${BASE_URL}/requests/cancel/${requestId}`;

  export const GET_ENVIRONMENT_ACTIVE_REQUESTS_URL = (environmentId: string) =>
    `${BASE_URL}/requests/statusInProgress?requestSource=${environmentId}`;

  export const RETRY_REQUEST_URL = (requestId: string) =>
    `${BASE_URL}/requests/retry/${requestId}`;
}
